import React from "react";
import Box from "@mui/material/Box";
import SEO from "@/components/SEO";

/*
  researchData_page.scss was 195 lines for a page that renders one iframe.
  Only `#research-data-frame` matched anything — the sixteen classes it also
  defined (`.research-data`, `.table-title`, `.color-0`…`.color-9` and the
  rest) belonged to a hand-built table this page stopped rendering long ago.
*/
const ResearchData = () => (
  <SEO title="Research Data">
    <Box
      component="iframe"
      title="Research Data"
      sx={{ height: "calc(100vh - 42px)", width: "100%" }}
      src="https://docs.google.com/document/d/e/2PACX-1vQ49WRxGtZ48HlUbs9mGUCrdsxmRosHHrFMx8rLvGJVub_FIoLxw1Kr5Zi4P23kBl-i2Ud1n26IItsB/pub?embedded=true"
    />
  </SEO>
);

export default ResearchData;
